import { jsx as p, Fragment as ie, jsxs as D } from "react/jsx-runtime";
import * as s from "react";
import { useState as be, forwardRef as xe, useRef as we, useCallback as Jt, useEffect as Ee } from "react";
import * as er from "react-dom";
import tr from "react-dom";
function I(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), r === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function $e(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function dt(...e) {
  return (t) => {
    let r = !1;
    const o = e.map((a) => {
      const n = $e(a, t);
      return !r && typeof n == "function" && (r = !0), n;
    });
    if (r)
      return () => {
        for (let a = 0; a < o.length; a++) {
          const n = o[a];
          typeof n == "function" ? n() : $e(e[a], null);
        }
      };
  };
}
function j(...e) {
  return s.useCallback(dt(...e), e);
}
function rr(e, t) {
  const r = s.createContext(t), o = (n) => {
    const { children: i, ...u } = n, d = s.useMemo(() => u, Object.values(u));
    return /* @__PURE__ */ p(r.Provider, { value: d, children: i });
  };
  o.displayName = e + "Provider";
  function a(n) {
    const i = s.useContext(r);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${n}\` must be used within \`${e}\``);
  }
  return [o, a];
}
function nr(e, t = []) {
  let r = [];
  function o(n, i) {
    const u = s.createContext(i), d = r.length;
    r = [...r, i];
    const l = (v) => {
      var _;
      const { scope: h, children: g, ...b } = v, c = ((_ = h == null ? void 0 : h[e]) == null ? void 0 : _[d]) || u, m = s.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ p(c.Provider, { value: m, children: g });
    };
    l.displayName = n + "Provider";
    function f(v, h) {
      var c;
      const g = ((c = h == null ? void 0 : h[e]) == null ? void 0 : c[d]) || u, b = s.useContext(g);
      if (b) return b;
      if (i !== void 0) return i;
      throw new Error(`\`${v}\` must be used within \`${n}\``);
    }
    return [l, f];
  }
  const a = () => {
    const n = r.map((i) => s.createContext(i));
    return function(u) {
      const d = (u == null ? void 0 : u[e]) || n;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...u, [e]: d } }),
        [u, d]
      );
    };
  };
  return a.scopeName = e, [o, or(a, ...t)];
}
function or(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const o = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(n) {
      const i = o.reduce((u, { useScope: d, scopeName: l }) => {
        const v = d(n)[`__scope${l}`];
        return { ...u, ...v };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var ue = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, ar = s.useId || (() => {
}), ir = 0;
function de(e) {
  const [t, r] = s.useState(ar());
  return ue(() => {
    r((o) => o ?? String(ir++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function F(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...r) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...r);
  }, []);
}
function ur({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [o, a] = sr({ defaultProp: t, onChange: r }), n = e !== void 0, i = n ? e : o, u = F(r), d = s.useCallback(
    (l) => {
      if (n) {
        const v = typeof l == "function" ? l(e) : l;
        v !== e && u(v);
      } else
        a(l);
    },
    [n, e, a, u]
  );
  return [i, d];
}
function sr({
  defaultProp: e,
  onChange: t
}) {
  const r = s.useState(e), [o] = r, a = s.useRef(o), n = F(t);
  return s.useEffect(() => {
    a.current !== o && (n(o), a.current = o);
  }, [o, a, n]), r;
}
var Oe = s.forwardRef((e, t) => {
  const { children: r, ...o } = e, a = s.Children.toArray(r), n = a.find(lr);
  if (n) {
    const i = n.props.children, u = a.map((d) => d === n ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : d);
    return /* @__PURE__ */ p(Ce, { ...o, ref: t, children: s.isValidElement(i) ? s.cloneElement(i, void 0, u) : null });
  }
  return /* @__PURE__ */ p(Ce, { ...o, ref: t, children: r });
});
Oe.displayName = "Slot";
var Ce = s.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const a = pr(r), n = dr(o, r.props);
    return r.type !== s.Fragment && (n.ref = t ? dt(t, a) : a), s.cloneElement(r, n);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
Ce.displayName = "SlotClone";
var cr = ({ children: e }) => /* @__PURE__ */ p(ie, { children: e });
function lr(e) {
  return s.isValidElement(e) && e.type === cr;
}
function dr(e, t) {
  const r = { ...t };
  for (const o in t) {
    const a = e[o], n = t[o];
    /^on[A-Z]/.test(o) ? a && n ? r[o] = (...u) => {
      n(...u), a(...u);
    } : a && (r[o] = a) : o === "style" ? r[o] = { ...a, ...n } : o === "className" && (r[o] = [a, n].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function pr(e) {
  var o, a;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var fr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], M = fr.reduce((e, t) => {
  const r = s.forwardRef((o, a) => {
    const { asChild: n, ...i } = o, u = n ? Oe : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function vr(e, t) {
  e && er.flushSync(() => e.dispatchEvent(t));
}
function hr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = F(e);
  s.useEffect(() => {
    const o = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [r, t]);
}
var mr = "DismissableLayer", Se = "dismissableLayer.update", gr = "dismissableLayer.pointerDownOutside", _r = "dismissableLayer.focusOutside", Ie, pt = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ft = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      onFocusOutside: n,
      onInteractOutside: i,
      onDismiss: u,
      ...d
    } = e, l = s.useContext(pt), [f, v] = s.useState(null), h = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, g] = s.useState({}), b = j(t, (y) => v(y)), c = Array.from(l.layers), [m] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), _ = c.indexOf(m), S = f ? c.indexOf(f) : -1, w = l.layersWithOutsidePointerEventsDisabled.size > 0, E = S >= _, C = wr((y) => {
      const R = y.target, O = [...l.branches].some((H) => H.contains(R));
      !E || O || (a == null || a(y), i == null || i(y), y.defaultPrevented || u == null || u());
    }, h), P = Er((y) => {
      const R = y.target;
      [...l.branches].some((H) => H.contains(R)) || (n == null || n(y), i == null || i(y), y.defaultPrevented || u == null || u());
    }, h);
    return hr((y) => {
      S === l.layers.size - 1 && (o == null || o(y), !y.defaultPrevented && u && (y.preventDefault(), u()));
    }, h), s.useEffect(() => {
      if (f)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Ie = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), Le(), () => {
          r && l.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Ie);
        };
    }, [f, h, r, l]), s.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), Le());
    }, [f, l]), s.useEffect(() => {
      const y = () => g({});
      return document.addEventListener(Se, y), () => document.removeEventListener(Se, y);
    }, []), /* @__PURE__ */ p(
      M.div,
      {
        ...d,
        ref: b,
        style: {
          pointerEvents: w ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: I(e.onFocusCapture, P.onFocusCapture),
        onBlurCapture: I(e.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: I(
          e.onPointerDownCapture,
          C.onPointerDownCapture
        )
      }
    );
  }
);
ft.displayName = mr;
var yr = "DismissableLayerBranch", br = s.forwardRef((e, t) => {
  const r = s.useContext(pt), o = s.useRef(null), a = j(t, o);
  return s.useEffect(() => {
    const n = o.current;
    if (n)
      return r.branches.add(n), () => {
        r.branches.delete(n);
      };
  }, [r.branches]), /* @__PURE__ */ p(M.div, { ...e, ref: a });
});
br.displayName = yr;
function wr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = F(e), o = s.useRef(!1), a = s.useRef(() => {
  });
  return s.useEffect(() => {
    const n = (u) => {
      if (u.target && !o.current) {
        let d = function() {
          vt(
            gr,
            r,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: u };
        u.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = d, t.addEventListener("click", a.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", a.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", n);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", n), t.removeEventListener("click", a.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Er(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = F(e), o = s.useRef(!1);
  return s.useEffect(() => {
    const a = (n) => {
      n.target && !o.current && vt(_r, r, { originalEvent: n }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, r]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Le() {
  const e = new CustomEvent(Se);
  document.dispatchEvent(e);
}
function vt(e, t, r, { discrete: o }) {
  const a = r.originalEvent.target, n = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && a.addEventListener(e, t, { once: !0 }), o ? vr(a, n) : a.dispatchEvent(n);
}
var pe = "focusScope.autoFocusOnMount", fe = "focusScope.autoFocusOnUnmount", ke = { bubbles: !1, cancelable: !0 }, Cr = "FocusScope", ht = s.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: o = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: n,
    ...i
  } = e, [u, d] = s.useState(null), l = F(a), f = F(n), v = s.useRef(null), h = j(t, (c) => d(c)), g = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (o) {
      let c = function(w) {
        if (g.paused || !u) return;
        const E = w.target;
        u.contains(E) ? v.current = E : $(v.current, { select: !0 });
      }, m = function(w) {
        if (g.paused || !u) return;
        const E = w.relatedTarget;
        E !== null && (u.contains(E) || $(v.current, { select: !0 }));
      }, _ = function(w) {
        if (document.activeElement === document.body)
          for (const C of w)
            C.removedNodes.length > 0 && $(u);
      };
      document.addEventListener("focusin", c), document.addEventListener("focusout", m);
      const S = new MutationObserver(_);
      return u && S.observe(u, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", c), document.removeEventListener("focusout", m), S.disconnect();
      };
    }
  }, [o, u, g.paused]), s.useEffect(() => {
    if (u) {
      We.add(g);
      const c = document.activeElement;
      if (!u.contains(c)) {
        const _ = new CustomEvent(pe, ke);
        u.addEventListener(pe, l), u.dispatchEvent(_), _.defaultPrevented || (Sr(Rr(mt(u)), { select: !0 }), document.activeElement === c && $(u));
      }
      return () => {
        u.removeEventListener(pe, l), setTimeout(() => {
          const _ = new CustomEvent(fe, ke);
          u.addEventListener(fe, f), u.dispatchEvent(_), _.defaultPrevented || $(c ?? document.body, { select: !0 }), u.removeEventListener(fe, f), We.remove(g);
        }, 0);
      };
    }
  }, [u, l, f, g]);
  const b = s.useCallback(
    (c) => {
      if (!r && !o || g.paused) return;
      const m = c.key === "Tab" && !c.altKey && !c.ctrlKey && !c.metaKey, _ = document.activeElement;
      if (m && _) {
        const S = c.currentTarget, [w, E] = Nr(S);
        w && E ? !c.shiftKey && _ === E ? (c.preventDefault(), r && $(w, { select: !0 })) : c.shiftKey && _ === w && (c.preventDefault(), r && $(E, { select: !0 })) : _ === S && c.preventDefault();
      }
    },
    [r, o, g.paused]
  );
  return /* @__PURE__ */ p(M.div, { tabIndex: -1, ...i, ref: h, onKeyDown: b });
});
ht.displayName = Cr;
function Sr(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const o of e)
    if ($(o, { select: t }), document.activeElement !== r) return;
}
function Nr(e) {
  const t = mt(e), r = Fe(t, e), o = Fe(t.reverse(), e);
  return [r, o];
}
function mt(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Fe(e, t) {
  for (const r of e)
    if (!Pr(r, { upTo: t })) return r;
}
function Pr(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function xr(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function $(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && xr(e) && t && e.select();
  }
}
var We = Or();
function Or() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = je(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = je(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function je(e, t) {
  const r = [...e], o = r.indexOf(t);
  return o !== -1 && r.splice(o, 1), r;
}
function Rr(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Ar = "Portal", gt = s.forwardRef((e, t) => {
  var u;
  const { container: r, ...o } = e, [a, n] = s.useState(!1);
  ue(() => n(!0), []);
  const i = r || a && ((u = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : u.body);
  return i ? tr.createPortal(/* @__PURE__ */ p(M.div, { ...o, ref: t }), i) : null;
});
gt.displayName = Ar;
function Dr(e, t) {
  return s.useReducer((r, o) => t[r][o] ?? r, e);
}
var ce = (e) => {
  const { present: t, children: r } = e, o = Tr(t), a = typeof r == "function" ? r({ present: o.isPresent }) : s.Children.only(r), n = j(o.ref, Mr(a));
  return typeof r == "function" || o.isPresent ? s.cloneElement(a, { ref: n }) : null;
};
ce.displayName = "Presence";
function Tr(e) {
  const [t, r] = s.useState(), o = s.useRef({}), a = s.useRef(e), n = s.useRef("none"), i = e ? "mounted" : "unmounted", [u, d] = Dr(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const l = Z(o.current);
    n.current = u === "mounted" ? l : "none";
  }, [u]), ue(() => {
    const l = o.current, f = a.current;
    if (f !== e) {
      const h = n.current, g = Z(l);
      e ? d("MOUNT") : g === "none" || (l == null ? void 0 : l.display) === "none" ? d("UNMOUNT") : d(f && h !== g ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, d]), ue(() => {
    if (t) {
      let l;
      const f = t.ownerDocument.defaultView ?? window, v = (g) => {
        const c = Z(o.current).includes(g.animationName);
        if (g.target === t && c && (d("ANIMATION_END"), !a.current)) {
          const m = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = m);
          });
        }
      }, h = (g) => {
        g.target === t && (n.current = Z(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        f.clearTimeout(l), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(u),
    ref: s.useCallback((l) => {
      l && (o.current = getComputedStyle(l)), r(l);
    }, [])
  };
}
function Z(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Mr(e) {
  var o, a;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var ve = 0;
function $r() {
  s.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? qe()), document.body.insertAdjacentElement("beforeend", e[1] ?? qe()), ve++, () => {
      ve === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ve--;
    };
  }, []);
}
function qe() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var T = function() {
  return T = Object.assign || function(t) {
    for (var r, o = 1, a = arguments.length; o < a; o++) {
      r = arguments[o];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, T.apply(this, arguments);
};
function _t(e, t) {
  var r = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, o = Object.getOwnPropertySymbols(e); a < o.length; a++)
      t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (r[o[a]] = e[o[a]]);
  return r;
}
function Ir(e, t, r) {
  if (r || arguments.length === 2) for (var o = 0, a = t.length, n; o < a; o++)
    (n || !(o in t)) && (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
  return e.concat(n || Array.prototype.slice.call(t));
}
var oe = "right-scroll-bar-position", ae = "width-before-scroll-bar", Lr = "with-scroll-bars-hidden", kr = "--removed-body-scroll-bar-size";
function he(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Fr(e, t) {
  var r = be(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(o) {
          var a = r.value;
          a !== o && (r.value = o, r.callback(o, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Wr = typeof window < "u" ? s.useLayoutEffect : s.useEffect, Be = /* @__PURE__ */ new WeakMap();
function jr(e, t) {
  var r = Fr(null, function(o) {
    return e.forEach(function(a) {
      return he(a, o);
    });
  });
  return Wr(function() {
    var o = Be.get(r);
    if (o) {
      var a = new Set(o), n = new Set(e), i = r.current;
      a.forEach(function(u) {
        n.has(u) || he(u, null);
      }), n.forEach(function(u) {
        a.has(u) || he(u, i);
      });
    }
    Be.set(r, e);
  }, [e]), r;
}
function qr(e) {
  return e;
}
function Br(e, t) {
  t === void 0 && (t = qr);
  var r = [], o = !1, a = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(n) {
      var i = t(n, o);
      return r.push(i), function() {
        r = r.filter(function(u) {
          return u !== i;
        });
      };
    },
    assignSyncMedium: function(n) {
      for (o = !0; r.length; ) {
        var i = r;
        r = [], i.forEach(n);
      }
      r = {
        push: function(u) {
          return n(u);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(n) {
      o = !0;
      var i = [];
      if (r.length) {
        var u = r;
        r = [], u.forEach(n), i = r;
      }
      var d = function() {
        var f = i;
        i = [], f.forEach(n);
      }, l = function() {
        return Promise.resolve().then(d);
      };
      l(), r = {
        push: function(f) {
          i.push(f), l();
        },
        filter: function(f) {
          return i = i.filter(f), r;
        }
      };
    }
  };
  return a;
}
function Ur(e) {
  e === void 0 && (e = {});
  var t = Br(null);
  return t.options = T({ async: !0, ssr: !1 }, e), t;
}
var yt = function(e) {
  var t = e.sideCar, r = _t(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return s.createElement(o, T({}, r));
};
yt.isSideCarExport = !0;
function Vr(e, t) {
  return e.useMedium(t), yt;
}
var bt = Ur(), me = function() {
}, le = s.forwardRef(function(e, t) {
  var r = s.useRef(null), o = s.useState({
    onScrollCapture: me,
    onWheelCapture: me,
    onTouchMoveCapture: me
  }), a = o[0], n = o[1], i = e.forwardProps, u = e.children, d = e.className, l = e.removeScrollBar, f = e.enabled, v = e.shards, h = e.sideCar, g = e.noIsolation, b = e.inert, c = e.allowPinchZoom, m = e.as, _ = m === void 0 ? "div" : m, S = e.gapMode, w = _t(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = h, C = jr([r, t]), P = T(T({}, w), a);
  return s.createElement(
    s.Fragment,
    null,
    f && s.createElement(E, { sideCar: bt, removeScrollBar: l, shards: v, noIsolation: g, inert: b, setCallbacks: n, allowPinchZoom: !!c, lockRef: r, gapMode: S }),
    i ? s.cloneElement(s.Children.only(u), T(T({}, P), { ref: C })) : s.createElement(_, T({}, P, { className: d, ref: C }), u)
  );
});
le.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
le.classNames = {
  fullWidth: ae,
  zeroRight: oe
};
var zr = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Hr() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = zr();
  return t && e.setAttribute("nonce", t), e;
}
function Gr(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Kr(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Yr = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = Hr()) && (Gr(t, r), Kr(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Xr = function() {
  var e = Yr();
  return function(t, r) {
    s.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, wt = function() {
  var e = Xr(), t = function(r) {
    var o = r.styles, a = r.dynamic;
    return e(o, a), null;
  };
  return t;
}, Zr = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ge = function(e) {
  return parseInt(e || "", 10) || 0;
}, Qr = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ge(r), ge(o), ge(a)];
}, Jr = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Zr;
  var t = Qr(e), r = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - r + t[2] - t[0])
  };
}, en = wt(), z = "data-scroll-locked", tn = function(e, t, r, o) {
  var a = e.left, n = e.top, i = e.right, u = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Lr, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(u, "px ").concat(o, `;
  }
  body[`).concat(z, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(n, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(u, "px ").concat(o, `;
    `),
    r === "padding" && "padding-right: ".concat(u, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(oe, ` {
    right: `).concat(u, "px ").concat(o, `;
  }
  
  .`).concat(ae, ` {
    margin-right: `).concat(u, "px ").concat(o, `;
  }
  
  .`).concat(oe, " .").concat(oe, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(ae, " .").concat(ae, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(z, `] {
    `).concat(kr, ": ").concat(u, `px;
  }
`);
}, Ue = function() {
  var e = parseInt(document.body.getAttribute(z) || "0", 10);
  return isFinite(e) ? e : 0;
}, rn = function() {
  s.useEffect(function() {
    return document.body.setAttribute(z, (Ue() + 1).toString()), function() {
      var e = Ue() - 1;
      e <= 0 ? document.body.removeAttribute(z) : document.body.setAttribute(z, e.toString());
    };
  }, []);
}, nn = function(e) {
  var t = e.noRelative, r = e.noImportant, o = e.gapMode, a = o === void 0 ? "margin" : o;
  rn();
  var n = s.useMemo(function() {
    return Jr(a);
  }, [a]);
  return s.createElement(en, { styles: tn(n, !t, a, r ? "" : "!important") });
}, Ne = !1;
if (typeof window < "u")
  try {
    var Q = Object.defineProperty({}, "passive", {
      get: function() {
        return Ne = !0, !0;
      }
    });
    window.addEventListener("test", Q, Q), window.removeEventListener("test", Q, Q);
  } catch {
    Ne = !1;
  }
var B = Ne ? { passive: !1 } : !1, on = function(e) {
  return e.tagName === "TEXTAREA";
}, Et = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !on(e) && r[t] === "visible")
  );
}, an = function(e) {
  return Et(e, "overflowY");
}, un = function(e) {
  return Et(e, "overflowX");
}, Ve = function(e, t) {
  var r = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var a = Ct(e, o);
    if (a) {
      var n = St(e, o), i = n[1], u = n[2];
      if (i > u)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== r.body);
  return !1;
}, sn = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    r,
    o
  ];
}, cn = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    r,
    o
  ];
}, Ct = function(e, t) {
  return e === "v" ? an(t) : un(t);
}, St = function(e, t) {
  return e === "v" ? sn(t) : cn(t);
}, ln = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, dn = function(e, t, r, o, a) {
  var n = ln(e, window.getComputedStyle(t).direction), i = n * o, u = r.target, d = t.contains(u), l = !1, f = i > 0, v = 0, h = 0;
  do {
    var g = St(e, u), b = g[0], c = g[1], m = g[2], _ = c - m - n * b;
    (b || _) && Ct(e, u) && (v += _, h += b), u instanceof ShadowRoot ? u = u.host : u = u.parentNode;
  } while (
    // portaled content
    !d && u !== document.body || // self content
    d && (t.contains(u) || t === u)
  );
  return (f && Math.abs(v) < 1 || !f && Math.abs(h) < 1) && (l = !0), l;
}, J = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ze = function(e) {
  return [e.deltaX, e.deltaY];
}, He = function(e) {
  return e && "current" in e ? e.current : e;
}, pn = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, fn = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, vn = 0, U = [];
function hn(e) {
  var t = s.useRef([]), r = s.useRef([0, 0]), o = s.useRef(), a = s.useState(vn++)[0], n = s.useState(wt)[0], i = s.useRef(e);
  s.useEffect(function() {
    i.current = e;
  }, [e]), s.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var c = Ir([e.lockRef.current], (e.shards || []).map(He), !0).filter(Boolean);
      return c.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), c.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var u = s.useCallback(function(c, m) {
    if ("touches" in c && c.touches.length === 2 || c.type === "wheel" && c.ctrlKey)
      return !i.current.allowPinchZoom;
    var _ = J(c), S = r.current, w = "deltaX" in c ? c.deltaX : S[0] - _[0], E = "deltaY" in c ? c.deltaY : S[1] - _[1], C, P = c.target, y = Math.abs(w) > Math.abs(E) ? "h" : "v";
    if ("touches" in c && y === "h" && P.type === "range")
      return !1;
    var R = Ve(y, P);
    if (!R)
      return !0;
    if (R ? C = y : (C = y === "v" ? "h" : "v", R = Ve(y, P)), !R)
      return !1;
    if (!o.current && "changedTouches" in c && (w || E) && (o.current = C), !C)
      return !0;
    var O = o.current || C;
    return dn(O, m, c, O === "h" ? w : E);
  }, []), d = s.useCallback(function(c) {
    var m = c;
    if (!(!U.length || U[U.length - 1] !== n)) {
      var _ = "deltaY" in m ? ze(m) : J(m), S = t.current.filter(function(C) {
        return C.name === m.type && (C.target === m.target || m.target === C.shadowParent) && pn(C.delta, _);
      })[0];
      if (S && S.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!S) {
        var w = (i.current.shards || []).map(He).filter(Boolean).filter(function(C) {
          return C.contains(m.target);
        }), E = w.length > 0 ? u(m, w[0]) : !i.current.noIsolation;
        E && m.cancelable && m.preventDefault();
      }
    }
  }, []), l = s.useCallback(function(c, m, _, S) {
    var w = { name: c, delta: m, target: _, should: S, shadowParent: mn(_) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== w;
      });
    }, 1);
  }, []), f = s.useCallback(function(c) {
    r.current = J(c), o.current = void 0;
  }, []), v = s.useCallback(function(c) {
    l(c.type, ze(c), c.target, u(c, e.lockRef.current));
  }, []), h = s.useCallback(function(c) {
    l(c.type, J(c), c.target, u(c, e.lockRef.current));
  }, []);
  s.useEffect(function() {
    return U.push(n), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", d, B), document.addEventListener("touchmove", d, B), document.addEventListener("touchstart", f, B), function() {
      U = U.filter(function(c) {
        return c !== n;
      }), document.removeEventListener("wheel", d, B), document.removeEventListener("touchmove", d, B), document.removeEventListener("touchstart", f, B);
    };
  }, []);
  var g = e.removeScrollBar, b = e.inert;
  return s.createElement(
    s.Fragment,
    null,
    b ? s.createElement(n, { styles: fn(a) }) : null,
    g ? s.createElement(nn, { gapMode: e.gapMode }) : null
  );
}
function mn(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const gn = Vr(bt, hn);
var Nt = s.forwardRef(function(e, t) {
  return s.createElement(le, T({}, e, { ref: t, sideCar: gn }));
});
Nt.classNames = le.classNames;
var _n = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, V = /* @__PURE__ */ new WeakMap(), ee = /* @__PURE__ */ new WeakMap(), te = {}, _e = 0, Pt = function(e) {
  return e && (e.host || Pt(e.parentNode));
}, yn = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var o = Pt(r);
    return o && e.contains(o) ? o : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, bn = function(e, t, r, o) {
  var a = yn(t, Array.isArray(e) ? e : [e]);
  te[r] || (te[r] = /* @__PURE__ */ new WeakMap());
  var n = te[r], i = [], u = /* @__PURE__ */ new Set(), d = new Set(a), l = function(v) {
    !v || u.has(v) || (u.add(v), l(v.parentNode));
  };
  a.forEach(l);
  var f = function(v) {
    !v || d.has(v) || Array.prototype.forEach.call(v.children, function(h) {
      if (u.has(h))
        f(h);
      else
        try {
          var g = h.getAttribute(o), b = g !== null && g !== "false", c = (V.get(h) || 0) + 1, m = (n.get(h) || 0) + 1;
          V.set(h, c), n.set(h, m), i.push(h), c === 1 && b && ee.set(h, !0), m === 1 && h.setAttribute(r, "true"), b || h.setAttribute(o, "true");
        } catch (_) {
          console.error("aria-hidden: cannot operate on ", h, _);
        }
    });
  };
  return f(t), u.clear(), _e++, function() {
    i.forEach(function(v) {
      var h = V.get(v) - 1, g = n.get(v) - 1;
      V.set(v, h), n.set(v, g), h || (ee.has(v) || v.removeAttribute(o), ee.delete(v)), g || v.removeAttribute(r);
    }), _e--, _e || (V = /* @__PURE__ */ new WeakMap(), V = /* @__PURE__ */ new WeakMap(), ee = /* @__PURE__ */ new WeakMap(), te = {});
  };
}, wn = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), a = _n(e);
  return a ? (o.push.apply(o, Array.from(a.querySelectorAll("[aria-live]"))), bn(o, a, r, "aria-hidden")) : function() {
    return null;
  };
}, Re = "Dialog", [xt, qo] = nr(Re), [En, A] = xt(Re), Ot = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: o,
    defaultOpen: a,
    onOpenChange: n,
    modal: i = !0
  } = e, u = s.useRef(null), d = s.useRef(null), [l = !1, f] = ur({
    prop: o,
    defaultProp: a,
    onChange: n
  });
  return /* @__PURE__ */ p(
    En,
    {
      scope: t,
      triggerRef: u,
      contentRef: d,
      contentId: de(),
      titleId: de(),
      descriptionId: de(),
      open: l,
      onOpenChange: f,
      onOpenToggle: s.useCallback(() => f((v) => !v), [f]),
      modal: i,
      children: r
    }
  );
};
Ot.displayName = Re;
var Rt = "DialogTrigger", At = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...o } = e, a = A(Rt, r), n = j(t, a.triggerRef);
    return /* @__PURE__ */ p(
      M.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Te(a.open),
        ...o,
        ref: n,
        onClick: I(e.onClick, a.onOpenToggle)
      }
    );
  }
);
At.displayName = Rt;
var Ae = "DialogPortal", [Cn, Dt] = xt(Ae, {
  forceMount: void 0
}), Tt = (e) => {
  const { __scopeDialog: t, forceMount: r, children: o, container: a } = e, n = A(Ae, t);
  return /* @__PURE__ */ p(Cn, { scope: t, forceMount: r, children: s.Children.map(o, (i) => /* @__PURE__ */ p(ce, { present: r || n.open, children: /* @__PURE__ */ p(gt, { asChild: !0, container: a, children: i }) })) });
};
Tt.displayName = Ae;
var se = "DialogOverlay", Mt = s.forwardRef(
  (e, t) => {
    const r = Dt(se, e.__scopeDialog), { forceMount: o = r.forceMount, ...a } = e, n = A(se, e.__scopeDialog);
    return n.modal ? /* @__PURE__ */ p(ce, { present: o || n.open, children: /* @__PURE__ */ p(Sn, { ...a, ref: t }) }) : null;
  }
);
Mt.displayName = se;
var Sn = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...o } = e, a = A(se, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p(Nt, { as: Oe, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ p(
        M.div,
        {
          "data-state": Te(a.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), W = "DialogContent", $t = s.forwardRef(
  (e, t) => {
    const r = Dt(W, e.__scopeDialog), { forceMount: o = r.forceMount, ...a } = e, n = A(W, e.__scopeDialog);
    return /* @__PURE__ */ p(ce, { present: o || n.open, children: n.modal ? /* @__PURE__ */ p(Nn, { ...a, ref: t }) : /* @__PURE__ */ p(Pn, { ...a, ref: t }) });
  }
);
$t.displayName = W;
var Nn = s.forwardRef(
  (e, t) => {
    const r = A(W, e.__scopeDialog), o = s.useRef(null), a = j(t, r.contentRef, o);
    return s.useEffect(() => {
      const n = o.current;
      if (n) return wn(n);
    }, []), /* @__PURE__ */ p(
      It,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: I(e.onCloseAutoFocus, (n) => {
          var i;
          n.preventDefault(), (i = r.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: I(e.onPointerDownOutside, (n) => {
          const i = n.detail.originalEvent, u = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || u) && n.preventDefault();
        }),
        onFocusOutside: I(
          e.onFocusOutside,
          (n) => n.preventDefault()
        )
      }
    );
  }
), Pn = s.forwardRef(
  (e, t) => {
    const r = A(W, e.__scopeDialog), o = s.useRef(!1), a = s.useRef(!1);
    return /* @__PURE__ */ p(
      It,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (n) => {
          var i, u;
          (i = e.onCloseAutoFocus) == null || i.call(e, n), n.defaultPrevented || (o.current || (u = r.triggerRef.current) == null || u.focus(), n.preventDefault()), o.current = !1, a.current = !1;
        },
        onInteractOutside: (n) => {
          var d, l;
          (d = e.onInteractOutside) == null || d.call(e, n), n.defaultPrevented || (o.current = !0, n.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = n.target;
          ((l = r.triggerRef.current) == null ? void 0 : l.contains(i)) && n.preventDefault(), n.detail.originalEvent.type === "focusin" && a.current && n.preventDefault();
        }
      }
    );
  }
), It = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: n, ...i } = e, u = A(W, r), d = s.useRef(null), l = j(t, d);
    return $r(), /* @__PURE__ */ D(ie, { children: [
      /* @__PURE__ */ p(
        ht,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: a,
          onUnmountAutoFocus: n,
          children: /* @__PURE__ */ p(
            ft,
            {
              role: "dialog",
              id: u.contentId,
              "aria-describedby": u.descriptionId,
              "aria-labelledby": u.titleId,
              "data-state": Te(u.open),
              ...i,
              ref: l,
              onDismiss: () => u.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ D(ie, { children: [
        /* @__PURE__ */ p(xn, { titleId: u.titleId }),
        /* @__PURE__ */ p(Rn, { contentRef: d, descriptionId: u.descriptionId })
      ] })
    ] });
  }
), De = "DialogTitle", Lt = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...o } = e, a = A(De, r);
    return /* @__PURE__ */ p(M.h2, { id: a.titleId, ...o, ref: t });
  }
);
Lt.displayName = De;
var kt = "DialogDescription", Ft = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...o } = e, a = A(kt, r);
    return /* @__PURE__ */ p(M.p, { id: a.descriptionId, ...o, ref: t });
  }
);
Ft.displayName = kt;
var Wt = "DialogClose", jt = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...o } = e, a = A(Wt, r);
    return /* @__PURE__ */ p(
      M.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: I(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
jt.displayName = Wt;
function Te(e) {
  return e ? "open" : "closed";
}
var qt = "DialogTitleWarning", [Bo, Bt] = rr(qt, {
  contentName: W,
  titleName: De,
  docsSlug: "dialog"
}), xn = ({ titleId: e }) => {
  const t = Bt(qt), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return s.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, On = "DialogDescriptionWarning", Rn = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Bt(On).contentName}}.`;
  return s.useEffect(() => {
    var n;
    const a = (n = e.current) == null ? void 0 : n.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, An = Ot, Dn = At, Tn = Tt, Mn = Mt, $n = $t, In = Lt, Ge = Ft, Ln = jt;
const kn = {
  LG: "lg"
};
function Fn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ke = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ye;
function Wn() {
  return Ye || (Ye = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (n = a(n, o(u)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(null, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var i = "";
        for (var u in n)
          t.call(n, u) && n[u] && (i = a(i, u));
        return i;
      }
      function a(n, i) {
        return i ? n ? n + " " + i : n + i : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ke)), Ke.exports;
}
var jn = Wn();
const Xe = /* @__PURE__ */ Fn(jn), qn = "_rotate_1xozj_1", Bn = "_dash_1xozj_1", G = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: qn,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: Bn,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, K = "purpur-spinner", Un = {
  SM: "sm"
}, Vn = ({
  ["data-testid"]: e,
  disabled: t = !1,
  negative: r = !1,
  size: o = Un.SM,
  ...a
}) => /* @__PURE__ */ p(
  "div",
  {
    className: Xe([G[K], G[`${K}--${o}`]]),
    "data-testid": e,
    ...a,
    children: /* @__PURE__ */ p("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ p(
      "circle",
      {
        className: Xe(G[`${K}__circle`], {
          [G[`${K}__circle--disabled`]]: t,
          [G[`${K}__circle--negative`]]: r
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function zn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ze = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Qe;
function Hn() {
  return Qe || (Qe = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (n = a(n, o.call(this, u)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var i = "";
        for (var u in n)
          t.call(n, u) && n[u] && (i = a(i, this && this[u] || u));
        return i;
      }
      function a(n, i) {
        return i ? n ? n + " " + i : n + i : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Ze)), Ze.exports;
}
var Gn = Hn();
const Kn = /* @__PURE__ */ zn(Gn), Yn = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, Xn = Kn.bind(Yn), k = "purpur-button", Zn = ({
  children: e,
  className: t,
  ["data-testid"]: r,
  disabled: o = !1,
  fullWidth: a = !1,
  iconOnly: n,
  loading: i = !1,
  negative: u = !1,
  onClick: d,
  size: l = "md",
  variant: f,
  type: v = "button",
  ...h
}, g) => {
  if (n && f === "destructive")
    return null;
  const b = Xn(
    [
      k,
      `${k}--${u ? `${f}-negative` : f}`,
      `${k}--${l}`
    ],
    {
      [`${k}--icon-only`]: n,
      [`${k}--negative`]: u,
      [`${k}--full-width`]: a,
      [`${k}--disabled`]: o || i
    },
    t
  ), c = (_) => {
    o || i ? _.preventDefault() : d && d(_);
  }, m = !!h["aria-disabled"] || o || i;
  return /* @__PURE__ */ D(
    "button",
    {
      className: b,
      "data-testid": r,
      type: v,
      ref: g,
      "aria-disabled": m,
      onClick: c,
      ...h,
      children: [
        i && /* @__PURE__ */ p(Vn, { size: l === kn.LG ? "xs" : "xxs", negative: u, disabled: m }),
        " ",
        e
      ]
    }
  );
}, Ut = xe(Zn);
Ut.displayName = "Button";
function Qn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Je = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var et;
function Jn() {
  return et || (et = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (n = a(n, o(u)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(null, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var i = "";
        for (var u in n)
          t.call(n, u) && n[u] && (i = a(i, u));
        return i;
      }
      function a(n, i) {
        return i ? n ? n + " " + i : n + i : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(Je)), Je.exports;
}
var eo = Jn();
const to = /* @__PURE__ */ Qn(eo), re = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, ro = {
  TITLE100: "title-100"
}, ne = "purpur-heading", Vt = ({
  children: e,
  className: t = "",
  enableHyphenation: r = !1,
  negative: o = !1,
  tag: a,
  variant: n = ro.TITLE100,
  ...i
}) => {
  const u = a, d = to([
    t,
    re[ne],
    re[`${ne}--${n}`],
    {
      [re[`${ne}--hyphens`]]: r,
      [re[`${ne}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ p(u, { className: d, ...i, children: e });
};
Vt.displayName = "Heading";
function no(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var tt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var rt;
function oo() {
  return rt || (rt = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (n = a(n, o.call(this, u)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var i = "";
        for (var u in n)
          t.call(n, u) && n[u] && (i = a(i, this && this[u] || u));
        return i;
      }
      function a(n, i) {
        return i ? n ? n + " " + i : n + i : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(tt)), tt.exports;
}
var ao = oo();
const io = /* @__PURE__ */ no(ao), uo = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, so = io.bind(uo), nt = "purpur-icon", co = "md", lo = (e) => e.filter((t) => Object.keys(t).length >= 1).map((t) => `${t.name}="${t.value}"`).join(" "), po = ({ content: e = "", title: t } = {}) => {
  const r = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    t ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = t ? `<title>${t}</title>` : "";
  return `<svg ${lo(r)}>${o}${e}</svg>`;
}, fo = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), zt = ({
  ["data-testid"]: e,
  svg: t,
  allyTitle: r,
  className: o,
  size: a = co,
  ...n
}) => {
  const i = po({
    content: fo(t.svg),
    title: r
  }), u = so(o, nt, `${nt}--${a}`);
  return /* @__PURE__ */ p(
    "span",
    {
      className: u,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: i },
      ...n
    }
  );
};
zt.displayName = "Icon";
const vo = {
  name: "close",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.864 4.864a.9.9 0 0 1 1.273 0L12 10.727l5.864-5.863a.9.9 0 0 1 1.272 1.272L13.273 12l5.863 5.864a.9.9 0 1 1-1.272 1.272L12 13.273l-5.863 5.863a.9.9 0 0 1-1.273-1.272L10.727 12 4.864 6.136a.9.9 0 0 1 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["close"],
  category: "utility"
}, Ht = (e) => /* @__PURE__ */ p(zt, { ...e, svg: vo });
Ht.displayName = "IconClose";
function ho(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ot = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var at;
function mo() {
  return at || (at = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (n = a(n, o(u)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(null, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var i = "";
        for (var u in n)
          t.call(n, u) && n[u] && (i = a(i, u));
        return i;
      }
      function a(n, i) {
        return i ? n ? n + " " + i : n + i : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ot)), ot.exports;
}
var go = mo();
const _o = /* @__PURE__ */ ho(go), Y = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, yo = {
  PARAGRAPH100: "paragraph-100"
}, X = "purpur-paragraph", Gt = ({
  ["data-testid"]: e,
  children: t,
  className: r,
  disabled: o,
  enableHyphenation: a = !1,
  negative: n = !1,
  variant: i = yo.PARAGRAPH100,
  ...u
}) => {
  const d = _o([
    r,
    Y[X],
    Y[`${X}--${i}`],
    {
      [Y[`${X}--hyphens`]]: a,
      [Y[`${X}--disabled`]]: o,
      [Y[`${X}--negative`]]: n
    }
  ]);
  return /* @__PURE__ */ p("p", { ...u, className: d, "data-testid": e, children: t });
};
Gt.displayName = "Paragraph";
function it(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function bo(...e) {
  return (t) => {
    let r = !1;
    const o = e.map((a) => {
      const n = it(a, t);
      return !r && typeof n == "function" && (r = !0), n;
    });
    if (r)
      return () => {
        for (let a = 0; a < o.length; a++) {
          const n = o[a];
          typeof n == "function" ? n() : it(e[a], null);
        }
      };
  };
}
var Kt = s.forwardRef((e, t) => {
  const { children: r, ...o } = e, a = s.Children.toArray(r), n = a.find(Eo);
  if (n) {
    const i = n.props.children, u = a.map((d) => d === n ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : d);
    return /* @__PURE__ */ p(Pe, { ...o, ref: t, children: s.isValidElement(i) ? s.cloneElement(i, void 0, u) : null });
  }
  return /* @__PURE__ */ p(Pe, { ...o, ref: t, children: r });
});
Kt.displayName = "Slot";
var Pe = s.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  if (s.isValidElement(r)) {
    const a = So(r), n = Co(o, r.props);
    return r.type !== s.Fragment && (n.ref = t ? bo(t, a) : a), s.cloneElement(r, n);
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
Pe.displayName = "SlotClone";
var wo = ({ children: e }) => /* @__PURE__ */ p(ie, { children: e });
function Eo(e) {
  return s.isValidElement(e) && e.type === wo;
}
function Co(e, t) {
  const r = { ...t };
  for (const o in t) {
    const a = e[o], n = t[o];
    /^on[A-Z]/.test(o) ? a && n ? r[o] = (...i) => {
      n(...i), a(...i);
    } : a && (r[o] = a) : o === "style" ? r[o] = { ...a, ...n } : o === "className" && (r[o] = [a, n].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function So(e) {
  var t, r;
  let o = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, a = o && "isReactWarning" in o && o.isReactWarning;
  return a ? e.ref : (o = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, a = o && "isReactWarning" in o && o.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var No = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Po = No.reduce((e, t) => {
  const r = s.forwardRef((o, a) => {
    const { asChild: n, ...i } = o, u = n ? Kt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), xo = "VisuallyHidden", Yt = s.forwardRef(
  (e, t) => /* @__PURE__ */ p(
    Po.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Yt.displayName = xo;
var Oo = Yt;
const Ro = ({
  asChild: e,
  children: t,
  className: r = "",
  ["data-testid"]: o
}) => /* @__PURE__ */ p(Oo, { asChild: e, "data-testid": o, className: r, children: t });
function Ao(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ye = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ut;
function Do() {
  return ut || (ut = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var n = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (n = a(n, o.call(this, u)));
        }
        return n;
      }
      function o(n) {
        if (typeof n == "string" || typeof n == "number")
          return this && this[n] || n;
        if (typeof n != "object")
          return "";
        if (Array.isArray(n))
          return r.apply(this, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
          return n.toString();
        var i = "";
        for (var u in n)
          t.call(n, u) && n[u] && (i = a(i, this && this[u] || u));
        return i;
      }
      function a(n, i) {
        return i ? n ? n + " " + i : n + i : n;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(ye)), ye.exports;
}
var To = Do();
const Mo = /* @__PURE__ */ Ao(To), $o = "_fadeIn_4aird_1", Io = {
  "purpur-modal-content": "_purpur-modal-content_4aird_1",
  fadeIn: $o,
  "purpur-modal-content__overlay": "_purpur-modal-content__overlay_4aird_30",
  "purpur-modal-content__close-button": "_purpur-modal-content__close-button_4aird_37",
  "purpur-modal-content__wrapper": "_purpur-modal-content__wrapper_4aird_47",
  "purpur-modal-content__wrapper-inner": "_purpur-modal-content__wrapper-inner_4aird_57",
  "purpur-modal-content__image-wrapper": "_purpur-modal-content__image-wrapper_4aird_61",
  "purpur-modal-content__header": "_purpur-modal-content__header_4aird_84",
  "purpur-modal-content__title": "_purpur-modal-content__title_4aird_97",
  "purpur-modal-content__description": "_purpur-modal-content__description_4aird_100",
  "purpur-modal-content__body": "_purpur-modal-content__body_4aird_103",
  "purpur-modal-content__body-inner": "_purpur-modal-content__body-inner_4aird_111",
  "purpur-modal-content__actions-buttons": "_purpur-modal-content__actions-buttons_4aird_123",
  "purpur-modal-content__notification": "_purpur-modal-content__notification_4aird_141",
  "purpur-modal-content--with-image": "_purpur-modal-content--with-image_4aird_144",
  "purpur-modal-content--overflow": "_purpur-modal-content--overflow_4aird_144",
  "purpur-modal-content__actions": "_purpur-modal-content__actions_4aird_123",
  "purpur-modal-content__actions-separator": "_purpur-modal-content__actions-separator_4aird_175",
  "purpur-modal-content--sticky-footer": "_purpur-modal-content--sticky-footer_4aird_185"
}, st = (e) => e.showCloseButton === !0, x = Mo.bind(Io), N = "purpur-modal-content", Lo = xe(
  ({
    ["data-testid"]: e,
    actions: t,
    children: r,
    className: o,
    description: a,
    disableCloseOnClickOutside: n,
    hideDescription: i,
    image: u,
    stickyButtons: d = !0,
    title: l,
    notification: f = void 0,
    zIndex: v,
    onCloseAutoFocus: h,
    ...g
  }, b) => {
    const { closeButtonAriaLabel: c, showCloseButton: m, ..._ } = g, [S, w] = be(!1), [E, C] = be(0), P = we(null), y = we(null), R = x([
      N,
      { [`${N}--with-image`]: !!u },
      { [`${N}--overflow`]: S },
      { [`${N}--sticky-footer`]: d },
      o
    ]), O = (L) => e ? `${e} ${L}` : void 0, H = (L) => {
      n && L.preventDefault();
    }, q = Jt(() => {
      if (!P.current || !y.current)
        return;
      const L = window.getComputedStyle(P.current, null), Zt = parseFloat(L.getPropertyValue("height")), Qt = y.current.offsetHeight;
      w(Zt < Qt), C(
        (P.current.offsetWidth ?? 0) - (P.current.clientWidth ?? 0)
      );
    }, []), Xt = (L) => {
      n && !m && L.preventDefault();
    };
    return Ee(() => (window.addEventListener("resize", q), () => {
      window.removeEventListener("resize", q);
    }), [q]), Ee(() => {
      q();
    }, [f, r, q]), /* @__PURE__ */ D(Tn, { children: [
      /* @__PURE__ */ p(Mn, { className: x(`${N}__overlay`), style: { zIndex: v } }),
      /* @__PURE__ */ D(
        $n,
        {
          ..._,
          className: R,
          "data-testid": e,
          ref: b,
          ...!a && { "aria-describedby": void 0 },
          onPointerDownOutside: H,
          onOpenAutoFocus: q,
          onEscapeKeyDown: Xt,
          onCloseAutoFocus: h,
          style: { zIndex: `calc(${v} + 1)` },
          children: [
            /* @__PURE__ */ D("div", { ref: P, className: x(`${N}__wrapper`), children: [
              st(g) && c && u && /* @__PURE__ */ p(
                ct,
                {
                  "aria-label": c,
                  hasImage: !0,
                  scrollbarWidth: E,
                  "data-testid": O("close-button")
                }
              ),
              /* @__PURE__ */ D("div", { ref: y, className: x(`${N}__wrapper-inner`), children: [
                /* @__PURE__ */ D("div", { className: x(`${N}__header`), children: [
                  st(g) && c && !u && /* @__PURE__ */ p(
                    ct,
                    {
                      "aria-label": c,
                      "data-testid": O("close-button")
                    }
                  ),
                  /* @__PURE__ */ p(
                    In,
                    {
                      asChild: !0,
                      className: x(`${N}__title`),
                      "data-testid": O("title"),
                      children: /* @__PURE__ */ p(Vt, { tag: "h2", variant: "title-200", children: l })
                    }
                  )
                ] }),
                u && /* @__PURE__ */ p(
                  "div",
                  {
                    className: x(`${N}__image-wrapper`),
                    "data-testid": O("image"),
                    children: u
                  }
                ),
                /* @__PURE__ */ p("div", { className: x(`${N}__body`), children: /* @__PURE__ */ D("div", { className: x(`${N}__body-inner`), children: [
                  a && i && /* @__PURE__ */ p(Ro, { asChild: !0, children: /* @__PURE__ */ p(Ge, { "data-testid": O("description"), children: a }) }),
                  a && !i && /* @__PURE__ */ p(
                    Ge,
                    {
                      asChild: !0,
                      className: x(`${N}__description`),
                      "data-testid": O("description"),
                      children: /* @__PURE__ */ p(Gt, { variant: "paragraph-100", children: a })
                    }
                  ),
                  /* @__PURE__ */ p("div", { children: r }),
                  !d && /* @__PURE__ */ p(lt, { actions: t, notification: f })
                ] }) })
              ] })
            ] }),
            d && /* @__PURE__ */ p(lt, { actions: t, notification: f })
          ]
        }
      )
    ] });
  }
), ct = ({
  ["aria-label"]: e,
  hasImage: t,
  scrollbarWidth: r,
  ["data-testid"]: o
}) => /* @__PURE__ */ p(Ln, { asChild: !0, children: /* @__PURE__ */ p(
  Ut,
  {
    variant: t ? "primary" : "tertiary-purple",
    negative: t,
    size: "sm",
    iconOnly: !0,
    "aria-label": e,
    className: x(`${N}__close-button`),
    style: { right: `calc(var(--purpur-spacing-100) + ${r || 0}px)` },
    "data-testid": o,
    children: /* @__PURE__ */ p(Ht, {})
  }
) }), lt = ({
  actions: e,
  notification: t
}) => {
  const r = we(null);
  return Ee(() => {
    var o, a;
    t && ((a = (o = r == null ? void 0 : r.current) == null ? void 0 : o.scrollIntoView) == null || a.call(o, !1));
  }, [t]), e ? /* @__PURE__ */ D("div", { className: x(`${N}__actions`), children: [
    /* @__PURE__ */ p("div", { className: x(`${N}__actions-buttons`), "data-testid": "modal actions", children: e }),
    t && /* @__PURE__ */ p("div", { className: x(`${N}__notification`), ref: r, children: t }),
    /* @__PURE__ */ p("span", { className: x(`${N}__actions-separator`) })
  ] }) : null;
}, ko = xe(
  ({ ["data-testid"]: e, children: t, className: r, ...o }, a) => /* @__PURE__ */ p(Dn, { asChild: !0, ref: a, "data-testid": e, className: r, ...o, children: t })
), Me = ({
  ["data-testid"]: e,
  children: t,
  open: r,
  onOpenChange: o
}) => /* @__PURE__ */ p(An, { open: r, onOpenChange: o, "data-testid": e, children: t });
Me.Trigger = ko;
Me.Content = Lo;
Me.displayName = "Modal";
export {
  Me as Modal
};
//# sourceMappingURL=modal.es.js.map
